import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Button, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import moment from 'moment';
import Pagination from "react-reactstrap-pagination";
import { toast } from 'react-toastify';
import { api2 } from '~/services/api';
import Loader from '~/components/Loader/Loader';
import { Container } from './styles';

export default class CoachHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            history: [],
            loading: false,
            email: '',
            selectedPage: 1,
            totalItems: 0,
            perPage: 20,
        };
    }

    handleSearch = async (e) => {
        if (e) e.preventDefault();
        this.loadData(1);
    }

    loadData = async (page = 1) => {
        const { email, perPage } = this.state;

        if (!email) {
            toast.warn('Insira um email de usuário');
            return;
        }

        this.setState({ loading: true });
        try {
            const { data } = await api2.get(`coach-history/user/email/${email}?page=${page}&limit=${perPage}`);

            this.setState({
                history: data.data || [],
                totalItems: data.total || 0,
                selectedPage: page,
                loading: false
            });
        } catch (error) {
            toast.error('Erro ao carregar histórico de coach');
            this.setState({ loading: false });
        }
    };

    render() {
        const { history, loading, email, totalItems, perPage, selectedPage } = this.state;

        return (
            <Container>
                {loading && <Loader />}

                <Row>
                    <Col>
                        <div className="page-title-box">
                            <Row>
                                <Col lg={7}>
                                    <h4 className="page-title">Histórico de treinadores do usuário</h4>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col lg={4}>
                        <form onSubmit={this.handleSearch}>
                            <InputGroup>
                                <Input
                                    placeholder="Email do usuário"
                                    value={email}
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                    type="email"
                                />
                                <InputGroupAddon addonType="append">
                                    <Button color="primary" type="submit">Buscar</Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </form>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card style={{ overflow: 'auto' }}>
                            <CardBody>
                                <table className="table table-centered table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Treinador</th>
                                            <th>Início</th>
                                            <th>Fim</th>
                                            <th>Criado em</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {history.map(item => (
                                            <tr key={item.id}>
                                                <td>{item.id}</td>
                                                <td>{item.coach?.name}</td>
                                                <td>{item.start_at ? moment(item.start_at).format('DD/MM/YYYY HH:mm') : '--'}</td>
                                                <td>{item.end_at ? moment(item.end_at).format('DD/MM/YYYY HH:mm') : 'Atual'}</td>
                                                <td>{moment(item.created_at).format('DD/MM/YYYY HH:mm')}</td>
                                            </tr>
                                        ))}
                                        {history.length === 0 && !loading && !!email && (
                                            <tr>
                                                <td colSpan="5" className="text-center">Nenhum histórico encontrado para este usuário</td>
                                            </tr>
                                        )}
                                        {!email && (
                                            <tr>
                                                <td colSpan="5" className="text-center">Busque por um email de usuário para ver o histórico</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {totalItems > perPage && (
                    <Row>
                        <Col xs={12} className="d-flex justify-content-center mt-3">
                            <Pagination
                                firstPageText="Início"
                                lastPageText="Fim"
                                previousPageText="Anterior"
                                nextPageText="Próximo"
                                totalItems={totalItems}
                                pageSize={perPage}
                                activePage={selectedPage}
                                onSelect={this.loadData}
                            />
                        </Col>
                    </Row>
                )}
            </Container>
        );
    }
}
